import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../auth/authSlice";
import wompiReducer from "./wompi/wompiSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  wompi: wompiReducer,
});

export default rootReducer;
